// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"e2b52188","2372":"c24bb80c"}[chunkId] + ".chunk.css";
};